import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class LoanStatusReportService {
  constructor(private http: HttpUtilService) {}

  LoanStatusReport(
    Type: string,
    FromDate: string,
    ToDate: string,
  ): Observable<any> {
    return this.http.post(
      "SalesReportService.asmx/LoanStatusReport",
      {
        model: {
          Type,
          FromDate,
          ToDate,
        },
      },
    );
  }
}
